import { render } from "./PageSucessView.vue?vue&type=template&id=908a9f48&scoped=true"
import script from "./PageSucessView.vue?vue&type=script&lang=js"
export * from "./PageSucessView.vue?vue&type=script&lang=js"

import "./PageSucessView.vue?vue&type=style&index=0&id=908a9f48&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908a9f48"]])

export default __exports__